import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css'; // Import default Amplify UI styles
import getEnvironmentConfig from './config/environment';
import Navigation from './components/Navigation';
import ChatAndDocPage from './pages/ChatAndDocPage';
import KnowledgeBase from './components/KnowledgeBase';
import StepperWorkflow from './components/StepperWorkflow';

Amplify.configure(getEnvironmentConfig());

function App() {
  const [activeView, setActiveView] = useState('workflow');
  const [docKey, setDocKey] = useState('');
  const [docContent, setDocContent] = useState('');
  const [docUrl, setDocUrl] = useState('');
  const [isPackage, setIsPackage] = useState(false);
  const [packageUrls, setPackageUrls] = useState(null);
  const [clientResetVersion, setClientResetVersion] = useState(0);
  
  // Get the environment config to use the correct API endpoint
  const envConfig = getEnvironmentConfig();
  const docCreationEndpoint = envConfig.aws_cloud_logic_custom.find(
    api => api.name === 'DocCreationAPI'
  )?.endpoint;

  useEffect(() => {
    if (docKey && docCreationEndpoint) {
      setDocUrl(`${docCreationEndpoint}/dev/download/${docKey}`);
    } else {
      setDocUrl('');
    }
  }, [docKey, docCreationEndpoint]);

  const handleNavClick = (view) => {
    setActiveView(view);
  };

  const handleStartNewClient = () => {
    setActiveView('workflow');
    setDocKey('');
    setDocContent('');
    setDocUrl('');
    setIsPackage(false);
    setPackageUrls(null);
    setClientResetVersion(prev => prev + 1);
  };

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Navigation
        activeView={activeView}
        onNavClick={handleNavClick}
        onStartNewClient={handleStartNewClient}
      />
      <main key={clientResetVersion} className="flex-grow overflow-hidden">
        {activeView === 'knowledge' && <KnowledgeBase />}
        {activeView === 'chatDoc' && (
          <ChatAndDocPage
            initialDocKey={docKey}
            initialDocUrl={docUrl}
            initialDocContent={docContent}
            setDocKey={setDocKey}
            setDocContent={setDocContent}
            isPackage={isPackage}
            packageUrls={packageUrls}
            setIsPackage={setIsPackage}
            setPackageUrls={setPackageUrls}
          />
        )}
        {activeView === 'workflow' && (
          <StepperWorkflow />
        )}
      </main>
    </div>
  );
}

// Authenticator configuration to fix password form accessibility warning
const authenticatorComponents = {
  ForceNewPassword: {
    FormFields() {
      return (
        <>
          {/* Hidden username field for accessibility */}
          <input
            type="hidden"
            name="username"
            autoComplete="username"
          />
        </>
      );
    }
  }
};

export default withAuthenticator(App, {
  components: authenticatorComponents
});
